export default {
  getRecordHeartbeatBloodPressureList:
    "BackEnd/getRecordHeartbeatBloodPressureList",
  getMyRecordHeartbeatBloodPressureList:
    "BackEnd/getMyRecordHeartbeatBloodPressureList",
  getRecordHeartbeatBloodPressureDetails:
    "BackEnd/getRecordHeartbeatBloodPressureDetails",
  setRecordHeartbeatBloodPressureData:
    "BackEnd/setRecordHeartbeatBloodPressureData",
  updateRecordHeartbeatBloodPressureData:
    "BackEnd/updateRecordHeartbeatBloodPressureData",
  deleteRecordHeartbeatBloodPressureData:
    "BackEnd/deleteRecordHeartbeatBloodPressureData",

  getRecordWeightList: "BackEnd/getRecordWeightList",
  getMyRecordWeightList: "BackEnd/getMyRecordWeightList",
  getRecordWeightDetails: "BackEnd/getRecordWeightDetails",
  setRecordWeightData: "BackEnd/setRecordWeightData",
  updateRecordWeightData: "BackEnd/updateRecordWeightData",
  deleteRecordWeightData: "BackEnd/deleteRecordWeightData",

  getRecordGlucoseList: "BackEnd/getRecordGlucoseList",
  getMyRecordGlucoseList: "BackEnd/getMyRecordGlucoseList",
  getRecordGlucoseDetails: "BackEnd/getRecordGlucoseDetails",
  setRecordGlucoseData: "BackEnd/setRecordGlucoseData",
  updateRecordGlucoseData: "BackEnd/updateRecordGlucoseData",
  deleteRecordGlucoseData: "BackEnd/deleteRecordGlucoseData",

  getRecordUncomfortableSymptomsList:
    "BackEnd/getRecordUncomfortableSymptomsList",
  getMyRecordUncomfortableSymptomsList:
    "BackEnd/getMyRecordUncomfortableSymptomsList",
  getRecordUncomfortableSymptomsDetails:
    "BackEnd/getRecordUncomfortableSymptomsDetails",
  setRecordUncomfortableSymptomsData:
    "BackEnd/setRecordUncomfortableSymptomsData",
  updateRecordUncomfortableSymptomsData:
    "BackEnd/updateRecordUncomfortableSymptomsData",
  deleteRecordUncomfortableSymptomsData:
    "BackEnd/deleteRecordUncomfortableSymptomsData",

  getRecordHealthBehaviorList: "BackEnd/getRecordHealthBehaviorList",
  getMyRecordHealthBehaviorList: "BackEnd/getMyRecordHealthBehaviorList",
  getRecordHealthBehaviorDetails: "BackEnd/getRecordHealthBehaviorDetails",
  setRecordHealthBehaviorData: "BackEnd/setRecordHealthBehaviorData",
  updateRecordHealthBehaviorData: "BackEnd/updateRecordHealthBehaviorData",
  deleteRecordHealthBehaviorData: "BackEnd/deleteRecordHealthBehaviorData",

  downloadCaseData: "BackEnd/downloadCaseData",
};
